import React from 'react';
import { useNavigate } from 'react-router';
import { 
  Box, 
  Toolbar, 
  Typography, 
  Container,
  useTheme,
  useMediaQuery,
  Button,
  Avatar
} from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import hive_logo from 'assets/images/hive_logo.png';
import { StyledAppBar, LogoWrapper, NavButton } from './styled';

function PublicNavBar() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  const navigateMenu = (target) => {
    if (target === 'Spaces') navigate('/');
    if (target === 'Communities') navigate('/communities');
    if (target === 'About us') navigate('/about-us');
  };
  
  const navigateHome = () => navigate('/');
  const navigateLogin = () => navigate('/login');

  return (
    <StyledAppBar position="sticky">
      <Container maxWidth="xl">
        <Toolbar 
          disableGutters 
          sx={{ 
            py: 1,
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          <LogoWrapper onClick={navigateHome}>
            <Box
              component="img"
              src={hive_logo}
              alt="Hivespace Logo"
              sx={{
                height: isMobile ? 24 : 32,
                width: 'auto'
              }}
            />
            <Typography
              variant="h6"
              sx={{
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: isMobile ? '.2rem' : '.3rem',
                background: 'linear-gradient(45deg, #FFA000, #FF6D00)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontSize: isMobile ? '0.9rem' : '1.25rem',
              }}
            >
              HIVESPACE
            </Typography>
          </LogoWrapper>

          {/* Navigation */}
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 0.5, md: 2 }
          }}>
            <NavButton
              onClick={() => navigateMenu('Spaces')}
              sx={{
                fontSize: { xs: '0.875rem', md: '1rem' },
                px: { xs: 1, md: 2 }
              }}
            >
              Spaces
            </NavButton>
            <NavButton
              onClick={() => navigateMenu('Communities')}
              sx={{
                fontSize: { xs: '0.875rem', md: '1rem' },
                px: { xs: 1, md: 2 }
              }}
            >
              Communities
            </NavButton>
            <NavButton
              onClick={() => navigateMenu('About us')}
              sx={{
                fontSize: { xs: '0.875rem', md: '1rem' },
                px: { xs: 1, md: 2 }
              }}
            >
              About us
            </NavButton>
            {isMobile ? (
              <Avatar
                onClick={navigateLogin}
                sx={{
                  width: 32,
                  height: 32,
                  bgcolor: 'transparent',
                  border: '1px solid',
                  borderColor: 'primary.main',
                  cursor: 'pointer',
                  color: 'primary.main',
                  '&:hover': {
                    bgcolor: 'rgba(0, 0, 0, 0.04)'
                  }
                }}
              >
                <PersonOutlineIcon sx={{ fontSize: 20 }} />
              </Avatar>
            ) : (
              <Button
                variant="outlined"
                onClick={navigateLogin}
                sx={{
                  color: 'primary.main',
                  borderColor: 'primary.main',
                  '&:hover': {
                    borderColor: 'primary.dark',
                    backgroundColor: 'rgba(0, 0, 0, 0.04)'
                  }
                }}
              >
                Login
              </Button>
            )}
          </Box>
        </Toolbar>
      </Container>
    </StyledAppBar>
  );
}

export default PublicNavBar;